var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c("div", { style: _vm.s.body }, [
        _c("div", { staticClass: "content-wrapper" }, [
          _c("div", { staticClass: "search-container" }, [
            _c("span", { staticClass: "search-icon" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userInput,
                  expression: "userInput"
                }
              ],
              staticClass: "search-input",
              attrs: { placeholder: _vm.$t("tokenCard.addToken.placeholder") },
              domProps: { value: _vm.userInput },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.userInput = $event.target.value
                }
              }
            })
          ]),
          _c(
            "div",
            { staticClass: "search-tips" },
            _vm._l(_vm.searchRes, function(token) {
              return _c(
                "div",
                {
                  staticClass: "search-tips__item",
                  class: {
                    active: _vm.selectedTokenIds.indexOf(token.tokenId) >= 0
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedTokenIds,
                        expression: "selectedTokenIds"
                      }
                    ],
                    attrs: { type: "checkbox", name: "addTokenSelected" },
                    domProps: {
                      value: token.tokenId,
                      checked: Array.isArray(_vm.selectedTokenIds)
                        ? _vm._i(_vm.selectedTokenIds, token.tokenId) > -1
                        : _vm.selectedTokenIds
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.selectedTokenIds,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = token.tokenId,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.selectedTokenIds = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedTokenIds = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedTokenIds = $$c
                        }
                      }
                    }
                  }),
                  _c("img", { attrs: { src: token.icon } }),
                  _c("div", { staticClass: "info" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(token.tokenName))
                      ]),
                      _c("div", { staticClass: "tag" }, [
                        _vm._v(
                          _vm._s(
                            _vm.token2Gate[token.tokenId]
                              ? _vm.token2Gate[token.tokenId].gateway
                              : ""
                          )
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "desc" }, [
                      _vm._v(_vm._s(token.tokenId))
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }